import React from "react";
import "./AbtProducts.css";
import img1 from "../assets/commercial-collagee.png";
import img2 from "../assets/passenger-collage.png";

import { Link } from "react-router-dom";

function AbtProducts() {
    const products = [
        {
            img: img1,
            title: "Commercial vehicles",
            desc: "Robust, lightweight castings for enhanced durability and efficiency.",
            link: "/commercial",
        },
        {
            img: img2,
            title: "Passenger vehicles", 
            desc: "High-performance components for next-generation mobility.",
            link: "/passenger",
        },
      
    ];

    return (
        <section className="products-section" id="products">
            <h2 className="products-title">Products</h2>
            <div className="title-underline"></div>
            <p className="products-tagline">
                Engineering the Future of Mobility, One Casting at a Time
            </p>
           

            <div className="products-container">
                {products.map((item, index) => (
                    <div className="product-card" key={index}>
                        <div className="product-img-wrap">
                            <img src={item.img} alt={item.title} className="product-img" />
                        </div>
                        <div className="product-info">
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                            <Link to={item.link} className="product-link">
                                Explore Products <span>↗</span>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default AbtProducts;
